import { render, staticRenderFns } from "./TributosForm.vue?vue&type=template&id=31ef5c5c&scoped=true&"
import script from "./TributosForm.vue?vue&type=script&lang=js&"
export * from "./TributosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef5c5c",
  null
  
)

export default component.exports